import { render, staticRenderFns } from "./QuestionConfigMultipleChoice.vue?vue&type=template&id=ac848cd0&scoped=true"
import script from "./QuestionConfigMultipleChoice.vue?vue&type=script&lang=js"
export * from "./QuestionConfigMultipleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac848cd0",
  null
  
)

export default component.exports